function ShowPopup (id) {
    var popupWindow = $('.popup-window-' + id);
    var screen=$(window);
    console.log((screen.height() - popupWindow.outerHeight()/2) + screen.scrollTop());

    $(".popup-booking").fadeIn();
    $("body").css("overflow","hidden");


    //if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
        popupWindow
            .css("position","absolute")
            .css("top", Math.max(0, ((screen.height() - popupWindow.outerHeight()) / 2) + screen.scrollTop()) + "px")
            .css("left", Math.max(0, ((screen.width() - popupWindow.outerWidth()) / 2) + screen.scrollLeft()) + "px");
    //}
    /*else {
        popupWindow.css({
            "marginLeft": -(popupWindow.outerWidth() / 2)
        });
    };*/

    if (popupWindow.height() > $(window).height()) {
        popupWindow.addClass("small");
        popupWindow.fadeIn();
    } else {
        popupWindow.fadeIn(function() {
            popupWindow.fadeIn();

            /*popupWindow.css({
                "marginTop": -(popupWindow.outerHeight() / 2),
                "top": "50%"
            });*/

            popupWindow.addClass("fixed");
        });
    }
}